import { useQuery } from "@tanstack/react-query";

import TenantAPI from "../../../../api/api/TenantAPI";

interface Props {
  paginaton: { Count: number; Page: number };
  tenantID?: string;
  onSuccess?: () => void;
  onError?: () => void;
}

const useOrphanCollections = ({ paginaton, tenantID }: Props) => {
  const collections = useQuery({
    queryKey: ["orphan-collections"],
    queryFn: async () =>
      TenantAPI.getOrphanCollections(paginaton, tenantID).then((res) => {
        return res.data.data;
      }),
    enabled: true,
  });

  return {
    collections: (collections.data?.collections ?? []) as { name: string }[],
    pagination: collections.data?.pagination,
    isLoading: collections.isLoading,
  };
};

export default useOrphanCollections;
